// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__36ybk","notes":"Notes_notes__P4LL9","note":"Notes_note__z6lU8","markdown":"Notes_markdown__1vdp0"};